import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import Loading from "components/Loading";
import Form from "components/Form";
import useId from "hooks/useId";
import {makeStyles} from "@material-ui/core";
import VS from "constants/ValidationShema";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import TextInput from "components/TextInput";
import DatePicker from "components/DatePicker";
import {connect} from "react-redux";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import PartsTable from "components/PartsTable";

const useStyle = makeStyles(theme => ({
    wrap: {
        minWidth: 600,
        minHeight: 40
    }
}));


function PapersGeneratorGzmLeadingDocument(
    {
        groupId,
        paper,
        onClose,
        formSubmit
    }) {

    const classes = useStyle();
    const [initData, setInitData] = useState(null)
    const [working, setWorking] = useState(null)

    useEffect(() => {
        PurchasingGroupStage1Service.getGzmLeadingDocument(groupId).then(resp => {
            if (resp) {
                setInitData(resp);
            } else {
                onClose();
            }
        });
        // eslint-disable-next-line
    }, [groupId])

    const formId = useId();
    const onSubmit = (values) => {
        setWorking(true);
        const data = {...values, memberIds: Object.keys(values.memberIds).filter(x => values.memberIds[x] === true).map(x => parseInt(x.substring(1)))}
        PurchasingGroupStage1Service.printGzmLeadingDocument(groupId, data).finally(onClose)
    }

    const getActions = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined', working));
        buttons.push(createButton(Tr('generate_paper'), () => formSubmit[formId](), undefined, working, undefined, working));
        return <MultiButton buttons={buttons}/>;
    }

    return (
        <Dialog
            open
            title={paper.name}
            titleCentered
            maxWidth="md"
            fullWidth={false}
            onClose={onClose}
            dialogActions={getActions()}
        >
            <div className={classes.wrap}>
                {
                    !initData ?
                        <Loading/> :
                        <>
                            <Form
                                initialValues={{
                                    ...initData.document,
                                    memberIds: initData.membersList.reduce((prev, cur) => {
                                        prev["_" + cur.id] = initData.document.memberIds && initData.document.memberIds.includes(cur.id);
                                        return prev;
                                    }, {}),
                                }}
                                validationSchema={VS.object({
                                    memberIds: VS.any(),
                                    documentNumber: VS.stringMaxNoRq(50),
                                    projectName: VS.stringMaxNoRq(200),
                                    resolutionDate: VS.dateTimeNoReq(),
                                    documentDeadline: VS.dateTimeNoReq(),
                                })}
                                onSubmit={onSubmit}
                                id={formId}
                            >
                                {(formikProps) => (<>
                                        <TextInput
                                            id="documentNumber"
                                            label={Tr("document_number")}
                                            formikProps={formikProps}
                                            disabled={working}
                                            limit={50}
                                        />

                                        <TextInput
                                            id="projectName"
                                            label={Tr("project_name")}
                                            formikProps={formikProps}
                                            disabled={working}
                                            limit={200}
                                        />

                                        <DatePicker
                                            id="resolutionDate"
                                            label={Tr('resolution_date')}
                                            formikProps={formikProps}
                                            disabled={working}
                                        />
                                        <br/>
                                        <DatePicker
                                            id="documentDeadline"
                                            label={Tr('documents_deadline')}
                                            formikProps={formikProps}
                                            disabled={working}
                                        />

                                        <PartsTable
                                            id="memberIds"
                                            label={Tr('purchasing_group_member_list')}
                                            formikProps={formikProps}
                                            elementList={initData.membersList.map(x => ({identity: "_" + x.id, name: x.name}))}
                                            disabled={working}
                                            required={false}
                                        />
                                    </>

                                )}
                            </Form>

                        </>
                }
            </div>
        </Dialog>
    )
}

PapersGeneratorGzmLeadingDocument.propTypes = {
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
    paper: PropTypes.object.isRequired
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(PapersGeneratorGzmLeadingDocument);